import { createSlice } from '@reduxjs/toolkit'
import {
  sendOtpAsync,
  sendOtpAsyncBuilder,
  verifyOtpAsync,
  verifyOtpAsyncBuilder,
} from './asyncRequests'
import { StorageUtils } from './storage'

export interface VerificationState {
  inputEmail: string 
  verifiedEmail: string | null
  otp: string
  isVerified: boolean
  verifyLoading: boolean
  resendLoading: boolean
  requestLoading: boolean
  error: string | null
  message: string | null
  otpSent: boolean
}

const savedState = StorageUtils.getVerificationState();
const initialState: VerificationState = {
  inputEmail: '',
  verifiedEmail: savedState?.email || null,
  otp: '',
  isVerified: savedState?.isVerified || false,
  verifyLoading: false,
  resendLoading: false,
  requestLoading: false,
  error: null,
  message: null,
  otpSent: false,
}


export const VerificationSlice = createSlice({
  name: 'verification',
  initialState,
  reducers: {
    clearVerification: (state) => {
      StorageUtils.clearVerificationState();
      return initialState;
    },
    resetFormFields: (state) => {
      state.inputEmail = ''
      state.otp = ''
    },
    setInputEmail: (state, action) => {
      state.inputEmail = action.payload
    },
    setOtp: (state, action) => {
      state.otp = action.payload
    },
  },
  extraReducers: (builder) => {
    sendOtpAsyncBuilder(builder)
    verifyOtpAsyncBuilder(builder)
  },
})

export const VerificationActions = {
  ...VerificationSlice.actions,
  sendOtpAsync,
  verifyOtpAsync
}

export const VerificationReducer = VerificationSlice.reducer
